/*
 * Copyright (c) 2020.
 * Simon
 */


export default function getValueFromArray(array, key, defaultValue) {

    let fixValue = array === undefined ? defaultValue : array[key];
    fixValue = fixValue === null ? defaultValue : fixValue;
    return fixValue;
}
